import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'

import { useGetApiV1UserMe } from '@testsa-com/common/src/codegen/generated/user'
import { SocketContextProvider } from '../contexts/SocketContext'
import { MenuHelper } from '../helpers/Menu.helper'
import { useUserStore } from '../stores/useUserStore'
import styles from '../styles/layout/Layout.module.scss'
import { Footer } from './Footer'
import { Head } from './Head'
import { Header } from './Header'

export const Layout = ({ children }: { children: JSX.Element }) => {
  const { t } = useTranslation('common')
  const links = MenuHelper.getLinks(t)

  const meQuery = useGetApiV1UserMe()
  useEffect(() => {
    if (meQuery.data?.body) {
      useUserStore.setState({
        me: meQuery.data?.body,
      })
    }
  }, [meQuery.data?.body])

  return (
    <SocketContextProvider>
      <Head title="Admin | TEST SA" description="TEST SA" />
      <Header links={links} />
      <main className={styles.main}>{children}</main>
      <Footer links={links} />
    </SocketContextProvider>
  )
}
